import { Injectable } from '@angular/core';
import { Router, Params, ActivatedRoute, ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Provider } from './provider.model';
import { ProviderService } from './provider.service';


@Injectable()
export class ProviderGuard implements Resolve<Provider> {

  constructor(public router: Router, private providerService: ProviderService) { }

  private providerId: string;

  resolve(route: ActivatedRouteSnapshot) {
    this.providerId = route.params['providerId'];
    return this.providerService.getProviderById(this.providerId);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/provider/provider.guard.ts